// ---------------------------------------------------------------------------
// Constants
// ---------------------------------------------------------------------------
export const EMPTY_FORM = {
  phoneNumber: '',
  name: '',
  department: '',
  qualifications: '',
  experience: '',
  email: '',
  photoUrl: '',
  languages: [],
  about: '',
  onlineFee: '',
  offlineFee: '',
  availableOnline: false,
  availableOffline: false,
  clinic: '',
  address: '',
  latitude: '',
  longitude: '',
  hospitalId: '',
};

// Order fields appear in the form (top to bottom).
export const FIELD_ORDER = [
  'phoneNumber', 'name', 'department', 'qualifications', 'experience',
  'email', 'languages', 'onlineFee', 'offlineFee', 'clinic', 'address',
];

// Human-readable labels for the error banner summary.
export const FIELD_LABELS = {
  phoneNumber: 'Phone number',
  name: 'Name',
  department: 'Department',
  qualifications: 'Qualifications',
  experience: 'Experience',
  email: 'Email',
  languages: 'Languages',
  onlineFee: 'Online fee',
  offlineFee: 'Offline fee',
  clinic: 'Clinic / hospital name',
  address: 'Address',
};